<template>
  <v-container fluid class="full-screen">
    <!-- 使用背景圖片 -->
    <v-img :src="backgroundImage" cover class="background-img"></v-img>

    <!-- 放置按鈕的容器 -->
    <v-container class="button-container">
      <v-row justify="center">
        <v-col cols="auto">
          <v-btn class="custom-btn" @click="navigateTo('tradition')"
            >傳統暨區域鐵路容量分析</v-btn
          >
        </v-col>
        <v-col cols="auto">
          <v-btn class="custom-btn" @click="navigateTo('urban')"
            >都會捷運容量分析</v-btn
          >
        </v-col>
        <v-col cols="auto">
          <v-btn class="custom-btn" @click="navigateTo('train')"
            >列車運轉曲線規劃</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <!-- 範本管理 Dialog -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>範本管理</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
          <v-tab value="tradition">傳統暨區域鐵路</v-tab>
          <v-tab value="urban">都會捷運</v-tab>
        </v-tabs>
        <v-window v-model="tab">
          <v-window-item value="tradition">
            <v-list>
              <v-list-item
                v-for="item in traditionTemplates"
                :key="item.id"
                :title="item.name"
              ></v-list-item>
            </v-list>
          </v-window-item>
          <v-window-item value="urban">
            <v-list>
              <v-list-item
                v-for="item in urbanTemplates"
                :key="item.id"
                :title="item.name"
              ></v-list-item>
            </v-list>
          </v-window-item>
        </v-window>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { inject } from 'vue';
import { account, rrca, mrtca } from "@/utils/api";

export default {
  data() {
    return {
      backgroundImage: require("@/assets/train-background.png"),
      isAuth0Enabled: process.env.VUE_APP_AUTH0_ENABLED !== 'false',
      dialog: false,
      tab: 'tradition',
      traditionTemplates: [],
      urbanTemplates: [],
      loading: false,
      isAdmin: false,
    };
  },
  mounted() {
    // Check if isAdmin is stored in localStorage
    const storedIsAdmin = localStorage.getItem('isAdmin');
    if (storedIsAdmin !== null) {
      this.isAdmin = storedIsAdmin === 'true';
    }

    if (this.isAuth0Enabled) {
      const auth0Client = inject('auth0Client'); 
      if (auth0Client && typeof auth0Client.getAccessTokenSilently === 'function') {
        auth0Client.getAccessTokenSilently()
          .then(token => {
            this.loginWithToken(token);
          })
          .catch(error => {
            console.error('Auth0: Failed to get access token silently:', error);
          });
      } else {
        console.warn('WelcomeView: Auth0 is enabled in config, but auth0Client is not available or not fully initialized.');
      }
    } else {
      // console.log('WelcomeView: Auth0 is disabled, skipping Auth0 specific logic in mounted hook.');
      // When Auth0 is disabled, we rely on 'customUserLoggedIn' from localStorage.
      // No specific action needed here for the custom login flow within this component,
      // as the router guard is responsible for protecting routes.
    }
  },
  methods: {
    navigateTo(section) {
      this.$router.push({ name: section });
    },
    loginWithToken(token) {
      // This method is part of the Auth0 flow.
      // It attempts to log in via a backend endpoint using an Auth0 token.
      if (token) {
        account.login(token) // Assumes account.login is for Auth0 token validation with backend
          .then(response => {
            if(response.Success) {
              console.log('Auth0 backend login successful:', response);
              // Save isAdmin status
              this.isAdmin = response.IsAdmin || false;
              // Store isAdmin in localStorage for persistent state
              localStorage.setItem('isAdmin', this.isAdmin.toString());
              // Depending on the backend response, you might want to align
              // 'customUserLoggedIn' or other local session markers here if needed,
              // though typically Auth0 manages its own session.
            } else {
              console.error('Auth0 backend login failed:', response);
            }
          })
          .catch(error => {
            console.error('Error during Auth0 backend login:', error);
          });
      } else {
        console.warn('loginWithToken called without a token.');
      }
    },
    async openTemplateDialog() {
      this.dialog = true;
      await this.fetchTraditionTemplates();
      await this.fetchUrbanTemplates();
    },
    async fetchTraditionTemplates() {
      this.loading = true;
      try {
        const response = await rrca.project.getTemplate();
        if (response.Success) {
          // Assuming the API returns a list of templates in a property, e.g., 'Templates'
          // Adjust if the structure is different.
          this.traditionTemplates = response.Templates || [];
        } else {
          console.error('Failed to fetch tradition templates:', response.Message);
          this.traditionTemplates = [];
        }
      } catch (error) {
        console.error('Error fetching tradition templates:', error);
        this.traditionTemplates = [];
      } finally {
        this.loading = false;
      }
    },
    async fetchUrbanTemplates() {
      this.loading = true;
      try {
        const response = await mrtca.project.getTemplate();
        if (response.Success) {
          // Assuming the API returns a list of templates in a property, e.g., 'Templates'
          // Adjust if the structure is different.
          this.urbanTemplates = response.Templates || [];
        } else {
          console.error('Failed to fetch urban templates:', response.Message);
          this.urbanTemplates = [];
        }
      } catch (error) {
        console.error('Error fetching urban templates:', error);
        this.urbanTemplates = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.full-screen {
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.template-management-btn-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
}
.background-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: brightness(0.7);
}
.button-container {
  position: relative;
  z-index: 2;
}
.custom-btn {
  font-size: 18px;
  font-weight: bold;
  background-color: white;
  color: black;
  padding: 12px 24px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
}
</style>
